import { Timeline, Flex } from 'antd'
import Popover from 'src/components/common/popover/Popover'
import styles from './SkillTimeline.module.less'
import { DataTestId, TextConstants } from 'src/constants/ui.constants'
import { getFormattedTime } from 'src/utils/common.utils'
import { ExpertProfileSkillValidatedDataRespType } from 'src/types/api.types'

const { SkillValidationLog } = TextConstants.SkillTimeline

export type SkillTimelineProps = {
    children: React.ReactNode
    title?: React.ReactNode
    skillValidations: ExpertProfileSkillValidatedDataRespType[]
}

const SkillTimeline: React.FC<SkillTimelineProps> = ({ skillValidations, children }) => {
    const popoverContent = (
        <Timeline
            items={skillValidations.map(skill => ({
                children: (
                    <div className={styles.skill}>
                        <div className={styles.skillHeader}>
                            <span className={styles.skillUpdatedAt}>
                                {getFormattedTime(skill.updatedAt ?? '--')}
                            </span>
                        </div>
                        <Flex justify="space-between">
                            <span>{skill.skillValidatedBy}</span>
                            <span>{skill.score}</span>
                        </Flex>
                    </div>
                ),
            }))}
            className={styles.timeline}
        />
    )

    return (
        <div data-testid={DataTestId.SkillTimeline}>
            <Popover
                content={popoverContent}
                title={<div className={styles.timelineTitle}>{SkillValidationLog}</div>}
                placement="right"
                style={{ width: 250 }}
            >
                {children}
            </Popover>
        </div>
    )
}

export default SkillTimeline
